import React from 'react';
import { createRoot } from 'react-dom/client';
import { GlobalProvider } from './GlobalState';
import App from './App';
// import * as serviceWorker from './serviceWorker'; // Disabled: Not a PWA

const rootElement = document.getElementById('root');
const rootContainer = createRoot(rootElement);
rootContainer.render(<GlobalProvider><App /></GlobalProvider>);

// serviceWorker.register(); // Disabled: Not a PWA - // If you want your app to work offline and load faster, you can change unregister() to register() below. Note this comes with some pitfalls. Learn more about service workers: http://bit.ly/CRA-PWA